exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom label {\n  float: left;\n}\n.facet-element-container {\n  font-size: 12px;\n}\n", ""]);

// exports
